/*
 * ```
 *
 *  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *     .       .       .       .       .       .       .       .       .       .       .       .
 *       . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *   .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *     . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *    .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *       8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *    . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *       8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *    . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *       @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *    .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *      .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *    .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *      .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *    .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *       ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *    . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *         .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *    .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 *  Copyright FortyFix(c) 2026.
 *  Title: onesignal.service.ts;
 *  Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/app/onesignal.service.ts;
 *  Description: ;
 *  Author: Della Porta Giovanni Battista;
 *  Created at: 27/01/26, 14:54;
 *  Updated at: 27/01/26, 14:54;
 *  ```
 */

import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import {UtilityService} from "./utility.service";


@Injectable({ providedIn: 'root' })
export class OneSignalService {

  static isEnabled(){
    return environment['oneSignalAppId']
  }


   waitForSdk = () =>
    new Promise<any>((resolve) => {
      const check = () => {
        if ((window as any).OneSignal?.Notifications) {
          resolve((window as any).OneSignal);
        } else {
          setTimeout(check, 50);
        }
      };
      check();
    });
  async onInit(): Promise<void> {
    const OneSignal = await this.waitForSdk();
    var path = UtilityService.getUrlSubfolder()?`/${UtilityService.getUrlSubfolder()}/`: '';
    await OneSignal.init({
      appId: environment['oneSignalAppId'],
      allowLocalhostAsSecureOrigin: true,
      serviceWorkerPath: `${path}OneSignalSDKWorker.js`,
      serviceWorkerUpdaterPath: `${path}OneSignalSDKWorker.js`,
      path:path,
      notifyButton: {
        enable: true,
      },
    });

    OneSignal.Notifications.addEventListener(
      'permissionChange',
      (event) => console.log('Permission:', event)
    );
  }
  async getUserId(): Promise<string | null> {
    return (await this.waitForSdk()).getUserId();
  }

  async registerForPush() {
    return (await this.waitForSdk()).registerForPushNotifications();
  }

 async onSubscriptionChange(callback: (isSubscribed: boolean) => void) {
    return (await this.waitForSdk()).User.addEventListener(
      'subscriptionChange',
      callback
    );
  }

  async waitForUserId(): Promise<string> {
    const OneSignal = await this.waitForSdk();

    // se già presente (caso più comune)
    const existingId = OneSignal.User?.onesignalId;
    if (existingId) {
      return existingId;
    }

    // altrimenti aspettiamo che venga creato
    return new Promise<string>((resolve) => {
      const interval = setInterval(() => {
        const id = OneSignal.User?.onesignalId;
        if (id) {
          clearInterval(interval);
          resolve(id);
        }
      }, 300);
    });
  }

  async waitForPushSubscriptionId(): Promise<string> {
    const OneSignal = await this.waitForSdk();

    // se già disponibile
    const subId = OneSignal.User?.PushSubscription?.id;
    if (subId) {
      return subId;
    }

    // attendiamo la creazione
    return new Promise<string>((resolve) => {
      const interval = setInterval(() => {
        const id = OneSignal.User?.PushSubscription?.id;
        if (id) {
          clearInterval(interval);
          resolve(id);
        }
      }, 300);
    });
  }

  storeUserID(){
    this.waitForPushSubscriptionId().then(x => {
      console.log(x);
      localStorage.setItem(`osUserId-${environment['oneSignalAppId']}`, x);
    });
  }
}


